const storeStatus = (type, list) => {
  return list.filter(item => {
    return item.status === type
  })[0].statusName
}
const userStatus = (type) => {
  const typeArr = ['启用', '禁用', '待激活']
  return typeArr[type]
}
const agentStatus = (type) => { //0-启用；-1-禁用；-2-删除,
  // const typeArr = ['启用', '禁用', '已注销']
  const typeArr = {0: '启用', '-1': '禁用', '-2': '删除'}
  return typeArr[type]
}
export {
  storeStatus,
  userStatus,
  agentStatus
}




// WEBPACK FOOTER //
// ./src/assets/js/filters.js